module.exports = __webpack_public_path__ + "img/add_video_af.692ad2c9.svg";